// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6520) return "static/chunks/e2c5e4d9-fa1035bdf7890e90.js";
	if (chunkId === 1507) return "static/chunks/18050da9-af2ecb7cc8daaea6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"104":"f3152e88457b2465","3576":"5feb98daaf37f1a1"}[chunkId] + ".js";
};